
import { defineComponent } from 'vue';
import { AppFormRow, AppInput, AppCard, AppSelect, AppButton } from '@/components';
import useIapAdd from '@/modules/iap/model/add';
import { ROUTE_NAME_IAP } from '@/modules/iap/router';

export default defineComponent({
    name: ROUTE_NAME_IAP.ADD,
    components: { AppFormRow, AppInput, AppSelect, AppButton, AppCard },
    setup() {
        const { v$, model, features, create } = useIapAdd();

        return { v$, model, features, create };
    }
});
